module.exports = __webpack_public_path__ + "static/img/1-2.d221be3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/1-2.png
// module id = gJ6q
// module chunks = 0